var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['button', _vm.secondary ? 'button--secondary' : 'button--primary'],attrs:{"type":_vm.type,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default"):_vm._e(),_c('loading-indicator',{attrs:{"loading":_vm.loading}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }